import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const GLASS = {
  surface: "linear-gradient(180deg, rgba(12,16,22,.92) 0%, rgba(8,11,17,.92) 60%)",
  border: "1px solid rgba(255,255,255,.08)",
  shadow: "0 10px 32px rgba(2,8,23,.45)",
  text: "#e5e7eb",
  subtext: "#9ca3af",
};

export default function NotificationsPanel() {
  return (
    <Card sx={{ borderRadius: 2, background: GLASS.surface, border: GLASS.border, boxShadow: GLASS.shadow, color: GLASS.text }}>
      <CardContent>
        <Typography sx={{ fontWeight: 1000, fontSize: 16, mb: 0.8 }}>Notifications</Typography>
        <Typography sx={{ color: GLASS.subtext, fontSize: 13, lineHeight: 1.7 }}>
          Here you will find notifications from PromosPay
        </Typography>
      </CardContent>
    </Card>
  );
}
